'use strict';

let env = {
    $window: window,
    $html: document.getElementsByTagName("html")[0],
    $mainContent: document.getElementById('barba-wrapper'),
    $body: document.body,
    $master: document.getElementById('master'),
    $mainNav: document.getElementById('jsView--mainnav'),
    $mainTransition: document.getElementById('jsView--transition'),
    $mainTransitionProgress: document.getElementById('jsView--progress'),
    $menuListeners : document.querySelectorAll('.jsMenu--listener'),
    $popinView : document.getElementById('jsView--popin'),
    $zoomView : document.getElementById('jsView--zoom'),
    $zoomOverlay: document.getElementById('jsView--zoomOverlay'),
    $launcher: document.getElementById('jsLauncher--view'),
    $btnBackUI : document.getElementById('jsBack'),
    framework: {},
    tablet: false,
    mobile: false,
    phone: false,
    desktop: false,
    ios: false,
    ie11: false,
    android: false,
    edge:false,
    orientation: false,
    isVisiting: false,
    isOldie: false,
    isTouch:'ontouchstart' in window
}

export default env;


// WEBPACK FOOTER //
// ./resources/js/base/env.js